import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { QA_NAME_CLEAR_BTN } from '../../../../constants/qa'
import { preventDefault } from '../../../../utils/events'
import Button, { BUTTON_HEIGHT_24 } from '../../../Button'
import { getEmailRecipientsCorrectValue } from '../../Email.utils'
import { DraggableWrapper } from '../DraggableWrapper'
import { getRecipientItemId } from '../EmailRecipientsField.utils'

import * as styles from './SelectedOptions.module.css'

function SelectedOptions({
  Tag,
  children,
  disabled,
  droppableIndex,
  errorItems,
  errorOptionKeys,
  isDragDisabled,
  isOpen,
  maxHeight,
  maxWidth,
  name,
  printer,
  ref,
  values,
  onClearAll,
  onDeleteOption,
}) {
  const { t } = useTranslation()

  const [firstItem, ...listItems] = getEmailRecipientsCorrectValue(values)

  const errorInputValue = values.find(i => !i.value)?.email

  const wrapperClassName = classNames(styles.wrapper, {
    [styles.disabled]: disabled,
  })

  return (
    <div className={wrapperClassName} ref={ref} style={{ maxHeight }}>
      {firstItem ? (
        <div
          className={styles.firstRow}
          style={{ '--first-row-max-width': maxWidth }}
        >
          {isOpen ? (
            <Button.Contained
              isLight
              height={BUTTON_HEIGHT_24}
              qaName={QA_NAME_CLEAR_BTN}
              text={t('Email.ClearAllBtnKey')}
              onClick={onClearAll}
              onMouseDown={preventDefault}
            />
          ) : null}
          <DraggableWrapper
            Tag={Tag}
            className={styles.firstTag}
            draggableItemClassName={styles.draggableItem}
            droppableIndex={droppableIndex}
            errorItems={errorItems}
            errorOptionKeys={errorOptionKeys}
            isDragDisabled={isDragDisabled || disabled}
            isOpen={isOpen}
            item={firstItem}
            printer={printer}
            sourceFieldId={name}
            onDeleteOption={onDeleteOption}
          />
        </div>
      ) : null}
      {listItems?.length > 0 || (!isOpen && errorInputValue) ? (
        <div
          className={styles.SelectedOptions}
          style={!firstItem ? { maxWidth } : EMPTY_OBJECT}
        >
          {listItems?.map(item => (
            <DraggableWrapper
              Tag={Tag}
              className={styles.tag}
              draggableItemClassName={styles.draggableItem}
              droppableIndex={droppableIndex}
              errorItems={errorItems}
              errorOptionKeys={errorOptionKeys}
              isDragDisabled={isDragDisabled || disabled}
              isOpen={isOpen}
              item={item}
              key={getRecipientItemId(item)}
              printer={printer}
              sourceFieldId={name}
              onDeleteOption={onDeleteOption}
            />
          ))}
          {!isOpen && errorInputValue ? (
            <span className={styles.errorInput}>{errorInputValue}</span>
          ) : null}
        </div>
      ) : null}
      {children}
    </div>
  )
}

export default SelectedOptions
